import $axios from '../api'
// import axios from 'axios'
let axios = $axios

const url1 = ES_URL
const url2 = ''
const getCityList = params => {
  return axios({
    url: url1 + 'km/position/GetCityList/index',
    params,
    headers: {'x-requested-with': 'del'},
    method: 'get'
    // withCredentials: true
  })
}

const placeSuggestion = params => {
  return axios({
    url: url1 + 'api/Address/placeSuggestion',
    params,
    headers: {'x-requested-with': 'del'},
    method: 'get'
    // withCredentials: true
  })
}

const getMapAdress = params => {
  return axios({
    url: url1 + 'api_v2/company/register/getMapAdress',
    params,
    headers: {'x-requested-with': 'del'},
    method: 'get'
    // withCredentials: true
  })
}

const getFenceCount = params => {
  return $axios({
    url: url2 + 'eos/coupon/orderManager/fence/getCount',
    params
  })
}

const createFence = params => {
  return $axios({
    url: url2 + 'eos/coupon/orderManager/fence/createFence',
    method: 'post',
    data: params // {...params, groupId: 1}
  })
}

const deleteFence = params => {
  return $axios({
    url: url2 + 'eos/coupon/orderManager/fence/deleteFence',
    // method: 'post',
    params
  })
}

const getFenceList = params => {
  return $axios({
    url: url2 + 'eos/coupon/orderManager/fence/getFenceList',
    params
  })
}
export default {
  getCityList,
  placeSuggestion,
  getMapAdress,
  getFenceCount,
  createFence,
  deleteFence,
  getFenceList
}
